/**
 * Play / pause arrivals video when it enters / leaves the viewport.
 */
if (!customElements.get('anniversary-arrivals')) {
  class AnniversaryArrivals extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-arrivals-video]');
      if (!this.video) return;

      this.video.pause();
      this._onIntersect = (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        }
      };

      this._io = new IntersectionObserver(this._onIntersect, {
        root: null,
        threshold: 0.25,
      });
      this._io.observe(this.video);
    }

    disconnectedCallback() {
      this._io?.disconnect();
      this._io = null;
      this.video?.pause();
    }
  }

  customElements.define('anniversary-arrivals', AnniversaryArrivals);
}
